import { render, staticRenderFns } from "./CourseClassifyMenu.vue?vue&type=template&id=59e8412a&scoped=true&"
import script from "./CourseClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./CourseClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./CourseClassifyMenu.vue?vue&type=style&index=0&id=59e8412a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e8412a",
  null
  
)

export default component.exports